import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../../components/Loader'
import List from './List'
import Filter from './Filter'
import MoreChips from './MoreChips'
import Chips from '../../../components/Chips'
import { ChipsCol, Root, Title, FilterSection, Message, Button, BlankPage, Image, PageTitle, MainContainer, MarginContainer } from './styles'
import { BottomSpacer, TableMargin } from './styles'
import { RootState } from 'store/types'
import { GetOfferInsightsAPI, GetOfferInsightStatsAPI, OfferInsightsFilterChange, GetUsersSettingsAPI, SetRangeDates } from 'features/Dealers/Performance/state/actions'
import { GetProfilePerformanceInsightStatsAPI } from 'features/Dealers/Performance/state/actions'
import { FilterItem } from 'features/Dealers/Performance/Filter/state/types';
import { DateRange, UserSetting } from 'features/Dealers/Performance/state/types';
import image from 'common/images/gmb-specials-empty.svg';
import * as _ from 'lodash';
import { CHIPS_NUMBER } from 'features/Dealers/Performance/constants';
import WidgetsPerformance from './Widgets'
import moment from 'moment';

const Performance = (props: any) => {
    const dispatch = useDispatch();
    const [filters, setFilters] = React.useState({ oem: [], platform: [], offerType: [], templateStatus: [] } as any);
    const [allFilters, setAllf] = React.useState([] as any);
    const [activeFilter, setActivef] = React.useState(false);
    const [orderBy, setOrderBy] = React.useState("");
    
    const rootProps = useSelector((rootState: RootState) => {
        return {
            stats: rootState.dealers.offerInsights.stats,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            filtersItems: rootState.dealers.performanceFilters.items,
            specials: rootState.dealers.offerInsights.specials,
            dateRange: rootState.dealers.offerInsights.datesRange,
            user:rootState.security.user,
            userSettings: rootState.dealers.offerInsights.userSettings
        }
    }, shallowEqual);

    React.useEffect(() => {
        if(rootProps.user?.email && !rootProps.userSettings) dispatch(GetUsersSettingsAPI(`c.user='${rootProps.user?.email}'`, 'c.user'));
    }
    , [rootProps.user?.email]);

    React.useEffect(() => {
        if(rootProps.userSettings) {
            let datesRange : DateRange = { startDate: moment(rootProps.userSettings.performanceReportDateRange.startDate, 'YYYY-MM-DD'), endDate: moment(rootProps.userSettings.performanceReportDateRange.endDate, 'YYYY-MM-DD') };
            if (datesRange.endDate.valueOf()!==rootProps.dateRange?.endDate.valueOf() || datesRange.startDate.valueOf()!==rootProps.dateRange?.startDate.valueOf())
                dispatch(SetRangeDates(datesRange)); 
        }
    }
    , [rootProps.userSettings]);

    React.useEffect(() => {
        if(rootProps.selectedDealer)
        {
            dispatch(GetOfferInsightStatsAPI(rootProps.selectedDealer?.id, rootProps.dateRange))
            dispatch(GetProfilePerformanceInsightStatsAPI(rootProps.selectedDealer?.id, rootProps.dateRange))
        }
    }
    , [rootProps.dateRange]);

    const handleRemoveChip = (index: number) => {

        const value = allFilters[index];
        setAllf(allFilters.filter((val: any, idx: number) => index !== idx));

        var type = Object.keys(filters).find(k => filters[k].includes(value));
        if (type) {
            let newList = filters[type].filter((item: any) => item !== value)
            setFilters({ ...filters, [type]: newList });            
            let strfilters = encodeURI(JSON.stringify(parseFilters(newList)));
            dispatch(OfferInsightsFilterChange(strfilters));

        }
    }
    const handleRemoveAllChip = () => {
        setAllf([] as any);
        setFilters({ oem: [], platform: [], offerType: [], templateStatus: [] } as any)
        let strfilters = encodeURI(JSON.stringify(parseFilters([])));
        dispatch(OfferInsightsFilterChange(strfilters));
    }
    const handleChageFilter = (value: any, type: string, add: boolean) => {
        let typeFilters = filters[type]
        if (add) {
            typeFilters.push(value);
            setAllf([...allFilters, value]);        
        }
        else {
            
            typeFilters = typeFilters.filter((item: any) => item !== value)            
            setAllf(allFilters.filter((item: any) => item !== value));
                       
        }
        setFilters({ ...filters, [type]: typeFilters });
        
        setActivef(true);        
        let strfilters = encodeURI(JSON.stringify(parseFilters(typeFilters)));
        dispatch(OfferInsightsFilterChange(strfilters));

    }

    const parseFilters = (filters: string[]): FilterItem[] => {
        var newfilters = filters.map(parseFilter);        
        return newfilters;
    }
    const parseFilter = (filter: string): FilterItem => {

        var filterItem = rootProps.filtersItems && rootProps.filtersItems.find(f => {
            if (f.displayName == filter)
                return f;
        });

        return {
            displayName: filterItem ? filterItem?.displayName : "",
            origin: filterItem ? filterItem.origin : "",
            activity: filterItem ? filterItem.activity : ""
        }
    }
 
    


    return (
        <MainContainer>
        <MarginContainer>
            <WidgetsPerformance/>
        </MarginContainer>
        <MarginContainer>
        <Root>
            <TableMargin>
            <Title>
            </Title>
            {
                !rootProps.stats ?
                    <Loader />
                    :
                    rootProps.stats.totalPosts === 0 ?
                        <BlankPage>
                            <Image>
                                <img src={image} />
                            </Image>
                            <Message>
                                You currently have no specials published.
                            </Message>
                            <Message>
                                Once you add any, you will be able to see their activity here.
                            </Message>
                            <Button onClick={() => {
                                if (rootProps.stats)
                                    window.open(rootProps.stats?.specials_url, "_blank");
                                }}>
                                Publish Specials to GBP
                            </Button>
                        </BlankPage>
                        :
                        <>
                            <FilterSection>
                                <Filter
                                    onChange={handleChageFilter}
                                    filters={filters}
                                    openMenu={false}
                                />
                                <ChipsCol>
                                    <Chips
                                        items={allFilters.slice(0, CHIPS_NUMBER)}
                                        handleRemove={handleRemoveChip} />
                                </ChipsCol>
                                {
                                    allFilters.length > CHIPS_NUMBER &&
                                    <MoreChips
                                        chips={allFilters.slice(CHIPS_NUMBER, allFilters.length)}
                                        handleRemove={handleRemoveChip}
                                        handleRemoveAlll={handleRemoveAllChip}
                                        nchips={CHIPS_NUMBER}
                                    />
                                }
                            </FilterSection>
                            <List
                                filters={filters}
                                activeFilter={activeFilter}
                                orderBy={orderBy}
                            />
                            <ChipsCol>
                                <Chips
                                    items={allFilters.slice(0, CHIPS_NUMBER)}
                                    handleRemove={handleRemoveChip} />
                            </ChipsCol>
                            {
                                allFilters.length > CHIPS_NUMBER &&
                                <MoreChips
                                    chips={allFilters.slice(CHIPS_NUMBER, allFilters.length)}
                                    handleRemove={handleRemoveChip}
                                    handleRemoveAlll={handleRemoveAllChip}
                                    nchips={CHIPS_NUMBER}
                                />
                            }
                        </>
            }
            </TableMargin>
        </Root>
        </MarginContainer>
        <BottomSpacer/>
        </MainContainer>
    )

}

export default Performance;